// src/admin/pages/AdminBanners.js
import React, { useEffect, useState, useContext } from "react";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaSave, FaToggleOn, FaToggleOff } from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminSaleBanner,
  saveAdminSaleBanner,
  toggleAdminSaleBanner,
} from "../../services/adminSaleBanner.api";
import { FaTag } from "react-icons/fa";

function AdminSaleBanner() {
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useContext(AdminLanguageContext);
  
  const [showConfirmSave, setShowConfirmSave] = useState(false);

const TEXT = {
  EN: {
    title: "Sale Banner",
    active: "Visible",
    inactive: "Hidden",
    toggle: "Toggle Visibility",
    save: "Save",
    saving: "Saving...",
    loading: "Loading...",

    titleEn: "Title (EN)",
    titleAr: "Title (AR)",
    descEn: "Description (EN)",
    descAr: "Description (AR)",
    discount: "Discount (%)",

    confirmSave: "Save changes to Sale Banner?",
    confirmDesc: "This will update the Sale Banner for all users.",

    saved: "Saved successfully",
    toggled: "Visibility updated",

    cancel: "Cancel",
    confirm: "Confirm",

    noPermission: "You do not have permission to manage the sale banner.",
  },

  AR: {
    title: "بانر التخفيضات",
    active: "ظاهر",
    inactive: "مخفي",
    toggle: "تغيير الظهور",
    save: "حفظ",
    saving: "جاري الحفظ...",
    loading: "جاري التحميل...",

    titleEn: "العنوان (EN)",
    titleAr: "العنوان (AR)",
    descEn: "الوصف (EN)",
    descAr: "الوصف (AR)",
    discount: "نسبة الخصم (%)",

    confirmSave: "هل تريد حفظ التعديلات؟",
    confirmDesc: "سيتم تطبيق التغييرات على بانر التخفيضات لجميع المستخدمين.",

    saved: "تم الحفظ بنجاح",
    toggled: "تم تحديث الظهور",

    cancel: "إلغاء",
    confirm: "تأكيد",

    noPermission: "ليس لديك صلاحية لإدارة بانر التخفيضات",
  },
}[lang];

  const adminUser = JSON.parse(localStorage.getItem("adminUser") || "{}");
const perms = JSON.parse(localStorage.getItem("staffPermissions") || {});
const isAdmin = adminUser.role === "admin";
const canAccess = isAdmin || perms.can_manage_banners;


  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [toast, setToast] = useState("");
  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2000);
  };

  const [form, setForm] = useState({
    title_en: "",
    title_ar: "",
    description_en: "",
    description_ar: "",
    discount: 40,
    is_active: 1,
  });

  const load = () => {
    setLoading(true);
    getAdminSaleBanner()
      .then((row) => {
        if (!row) {
          // if DB has no row yet, keep defaults (admin can Save to create)
          setForm((p) => ({ ...p }));
        } else {
          setForm({
            title_en: row.title_en || "",
            title_ar: row.title_ar || "",
            description_en: row.description_en || "",
            description_ar: row.description_ar || "",
            discount: Number(row.discount || 0),
            is_active: Number(row.is_active || 0),
          });
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleSave = async () => {
  setSaving(true);
  try {
    await saveAdminSaleBanner({
      title_en: form.title_en,
      title_ar: form.title_ar,
      description_en: form.description_en,
      description_ar: form.description_ar,
      discount: Number(form.discount) || 0,
    });
    showToast(TEXT.saved);
    load();
  } finally {
    setSaving(false);
    setShowConfirmSave(false);
  }
};


  const handleToggle = async () => {
    setSaving(true);
    try {
      await toggleAdminSaleBanner();
      showToast(TEXT.toggled);
      load();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="flex-1 lg:ml-64 transition-all duration-300">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="xl:p-3 sm:p-5 pt-4 sm:pt-5 animate-fadeSlide">
  <div className="max-w-[720px] mx-auto px-3 sm:px-0">
  {!canAccess && (
    <div className="bg-red-50 border border-red-200 rounded-xl p-6 text-center">
      <p className="text-red-700 font-semibold">
        {lang === "AR"
          ? "ليس لديك صلاحية لإدارة بانر التخفيضات"
          : "You do not have permission to manage the sale banner."}
      </p>
    </div>
  )}

  {canAccess && (
    <>

          {/* Toast */}
          {toast && (
  <div className="fixed bottom-5 right-5 z-[9999] animate-fade-in">
    <div className="min-w-[260px] max-w-[320px] bg-white border border-[#e1e3e5] rounded-[12px] shadow-[0_10px_25px_rgba(0,0,0,0.12)] px-4 py-3">
      
      <p className="text-[13px] text-[#202223] font-medium">
        {toast}
      </p>

    </div>
  </div>
)}

        <div className="flex items-center justify-between mb-6">

  {/* LEFT: ICON + TITLE */}
  <div className="flex items-center gap-3">

    <div className="w-8 h-8 rounded-[10px] bg-[#f1f2f3] flex items-center justify-center">
      <FaTag className="text-[#202223] text-[15px]" />
    </div>

    <div className="flex items-center gap-2">
      <h1 className="text-[20px] font-semibold text-[#202223]">
        {TEXT.title}
      </h1>

      <span
        className={`text-xs font-medium px-2 py-[3px] rounded-full ${
          form.is_active
            ? "bg-[#e3f1df] text-[#1f7a2e]"
            : "bg-[#f1f2f3] text-[#6d7175]"
        }`}
      >
        {form.is_active ? TEXT.active : TEXT.inactive}
      </span>
    </div>

  </div>


</div>

         {loading ? (
  <div className="bg-white border border-[#e3e3e3] rounded-[12px] p-4 animate-pulse space-y-4">

    {/* header skeleton */}
    <div className="flex justify-between items-center">
      <div className="h-6 w-32 bg-gray-200 rounded" />
      <div className="h-8 w-24 bg-gray-200 rounded" />
    </div>

    {/* inputs skeleton */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="h-10 bg-gray-200 rounded" />
      <div className="h-10 bg-gray-200 rounded" />
    </div>

    <div className="h-16 bg-gray-200 rounded" />
    <div className="h-16 bg-gray-200 rounded" />

    <div className="h-10 w-32 bg-gray-200 rounded" />

  </div>
) : (
            <div className="bg-white border border-[#e3e3e3] rounded-[12px] shadow-[0_1px_2px_rgba(0,0,0,0.06)] overflow-hidden">

  {/* CARD HEADER ACTIONS */}
  <div className="flex items-center justify-between px-4 py-3 border-b border-[#e1e3e5]">

    {/* LEFT → TOGGLE */}
    <button
      onClick={handleToggle}
      disabled={saving || loading}
      className={`h-[34px] px-3 rounded-[8px] text-[13px] font-medium flex items-center gap-1.5 border ${
        form.is_active
          ? "bg-[#eef7f3] border-[#008060] text-[#008060]"
          : "bg-white border-[#c9cccf] text-[#202223]"
      } ${saving || loading ? "opacity-60 cursor-not-allowed" : "hover:bg-[#f6f6f7]"}`}
    >
      {saving ? (
  <span className="flex items-center gap-2">
    <span className="w-3 h-3 border-2 border-gray-500 border-t-transparent rounded-full animate-spin" />
    {TEXT.toggle}
  </span>
) : (
  <>
    {form.is_active ? <FaToggleOn /> : <FaToggleOff />}
    {TEXT.toggle}
  </>
)}
    </button>

    {/* RIGHT → SAVE */}
    <button
      onClick={() => setShowConfirmSave(true)}
      disabled={saving}
      className={`h-[34px] px-3 text-[13px] rounded-[8px] bg-[#202223] text-white font-medium hover:bg-black transition ${
        saving ? "opacity-70 cursor-not-allowed" : ""
      }`}
    >
      {saving ? (
  <span className="flex items-center gap-2">
    <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
    {TEXT.saving}
  </span>
) : TEXT.save}
    </button>

  </div>

  {/* FORM BODY */}
  <div className="p-4 space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="text-[12px] font-medium text-gray-900 mb-1 block">{TEXT.titleEn}</label>
                  <input
                     className="
w-full
h-[36px]
px-3
text-[13px]
text-[#202223]
bg-white
border border-gray-500
rounded-[8px]
outline-none
transition
focus:border-[#2c6ecb]
focus:ring-1 focus:ring-[#2c6ecb]/20
"
                    value={form.title_en}
                    onChange={(e) => setForm((p) => ({ ...p, title_en: e.target.value }))}
                  />
                </div>

                <div>
                  <label className="text-[12px] font-medium text-gray-900 mb-1 block">{TEXT.titleAr}</label>
                  <input
                    className="
w-full
h-[36px]
px-3
text-[13px]
text-[#202223]
bg-white
border border-gray-500
rounded-[8px]
outline-none
transition
focus:border-[#2c6ecb]
focus:ring-1 focus:ring-[#2c6ecb]/20
"
                    value={form.title_ar}
                    onChange={(e) => setForm((p) => ({ ...p, title_ar: e.target.value }))}
                  />
                </div>
              </div>

<div className="pt-3 space-y-4">

              <div>
                <label className="text-[12px] font-medium text-gray-900 mb-1 block">{TEXT.descEn}</label>
                <textarea
                  rows={3}
                   className="w-full px-3 py-1.5 text-sm rounded-[8px] border border-gray-500
focus:border-[#2c6ecb] focus:ring-1 focus:ring-[#2c6ecb]/20 outline-none"
                  value={form.description_en}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, description_en: e.target.value }))
                  }
                />
              </div>

              <div>
                <label className="text-[12px] font-medium text-gray-900 mb-1 block">{TEXT.descAr}</label>
                <textarea
                  rows={3}
                   className="w-full px-3 py-1.5 text-sm border rounded-[8px] border border-gray-500
focus:border-[#2c6ecb] focus:ring-1 focus:ring-[#2c6ecb]/20 outline-none"
                  value={form.description_ar}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, description_ar: e.target.value }))
                  }
                />
              </div>
  
</div>
              {/* DISCOUNT */}
<div className="max-w-[220px]">
  
  <label className="text-[12px] font-medium text-gray-900 mb-1 block">
    {TEXT.discount}
  </label>

  <input
    type="number"
    min={0}
    max={95}
    className="
w-full
h-[36px]
px-3
text-[13px]
text-[#202223]
bg-white
border border-gray-500
rounded-[8px]
outline-none
transition
focus:border-[#2c6ecb]
focus:ring-1 focus:ring-[#2c6ecb]/20
"
    value={form.discount}
    onChange={(e) =>
      setForm((p) => ({ ...p, discount: e.target.value }))
    }
  />

</div>
            </div>
           
            </div>
          )}
          
          {showConfirmSave && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div
      className="bg-white rounded-[18px] border border-[#e1e3e5] p-6 w-[360px] shadow-2xl"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <h3 className="text-lg font-bold text-gray-800 mb-2">
        {TEXT.confirmSave}
      </h3>

      <p className="text-sm text-gray-600 mb-6">
        {lang === "EN"
          ? "This will update the Sale Banner for all users."
          : "سيتم تطبيق التغييرات على بانر التخفيضات لجميع المستخدمين."}
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowConfirmSave(false)}
          className="h-[38px] px-4 rounded-[10px] border border-[#c9cccf] bg-white text-[#202223] hover:bg-[#f1f2f3]"
        >
          {lang === "EN" ? "Cancel" : "إلغاء"}
        </button>

        <button
          onClick={handleSave}
          disabled={saving}
          className="h-[38px] px-4 rounded-[10px] bg-[#202223] text-white hover:bg-black transition"
        >
          {lang === "EN" ? "Confirm" : "تأكيد"}
        </button>
      </div>
    </div>
  </div>
)}
    </>
  )}
</div>
        </main>
      </div>
    </div>
  );
}

export default AdminSaleBanner;

